module.exports = __webpack_public_path__ + "static/media/Bills_header_categories.b08af262.svg";